module.exports = __webpack_public_path__ + "static/media/bennett_hicks_rodriguez.ad222203.jpg";